<template>
  <div class="topbar">
    <nav class="navbar top-navbar navbar-expand-md navbar-dark">
      <div
        class="navbar-header"
        v-bind:style="{
          'background-color': cia.color_fondo_logo
        }"
      >
        <!-- This is for the sidebar toggle which is visible on mobile only -->
        <a
          class="nav-toggler waves-effect waves-light d-block d-md-none"
          href="javascript:void(0)"
        >
          <i id="option_abrir_sidever" class="ti-menu ti-close"></i>
        </a>
        <a class="navbar-brand" v-on:click.prevent="Dashboard">
          <span class="logo-text">
            <!-- dark Logo text -->
            <img
              src="static/libs_template/assets/images/logo-text.png"
              alt="homepage"
              class="dark-logo"
            />
            <!-- Light Logo text
                        <img src="static/libs_template/assets/images/logo-light-text.png" class="light-logo" alt="homepage" />
                         -->
            <img
              :key="logoHeaderSrc"
              :src="logoHeaderSrc"
              referrerpolicy="no-referrer"
              style="max-width: 200px; max-height: 60px"
              class="light-logo"
              alt="homepage"
              @error="onLogoHeaderError"
            />
          </span>
        </a>
        <a
          class="topbartoggler d-block d-md-none waves-effect waves-light"
          href="javascript:void(0)"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <i class="ti-more"></i>
        </a>
      </div>
      <div
        class="navbar-collapse collapse"
        v-bind:style="{
          color: cia.color_texto_header,
          'background-color': cia.color_fondo_header
        }"
        id="navbarSupportedContent"
      >
        <ul
          v-bind:style="{
            color: cia.color_texto_header
          }"
          class="navbar-nav float-left"
        >
          <li
            v-bind:style="{
              color: cia.color_texto_header
            }"
            class="nav-item d-none d-md-block"
          >
            <a
              v-bind:style="{
                color: cia.color_texto_header
              }"
              class="nav-link sidebartoggler waves-effect waves-light"
              href="javascript:void(0)"
              data-sidebartype="mini-sidebar"
            >
              <i
                v-bind:style="{
                  color: cia.color_texto_header
                }"
                class="sl-icon-menu font-20"
              />
            </a>
          </li>
          <li
            v-bind:style="{
              color: cia.color_texto_header
            }"
            class="nav-item dropdown"
          >
            <a
              v-bind:style="{
                color: cia.color_texto_header
              }"
              class="nav-link dropdown-toggle waves-effect waves-dark"
              href=""
              v-on:click="Actualizar_Notificaciones"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i
                v-bind:style="{
                  color: cia.color_texto_header
                }"
                class="ti-bell font-20"
                v-if="total_notificaciones == 0"
              />
              <span
                v-bind:style="{
                  color: cia.color_texto_header
                }"
                class="badge-notification mt-5"
                v-bind:data-badge="total_notificaciones"
                v-else
              >
                <i
                  v-bind:style="{
                    color: cia.color_texto_header
                  }"
                  class="ti-bell font-20"
                />
              </span>
            </a>
            <div
              v-bind:style="{
                color: cia.color_texto_header
              }"
              class="dropdown-menu mailbox animated bounceInDown"
            >
              <span
                v-bind:style="{
                  color: cia.color_texto_header
                }"
                class="with-arrow"
              >
                <span
                  v-bind:style="{
                    color: cia.color_texto_header
                  }"
                  class="bg-primary"
                />
              </span>
              <ul class="list-style-none">
                <li>
                  <div class="drop-title bg-danger text-white">
                    <h4 class="m-b-0 m-t-5" v-if="total_notificaciones > 1">
                      {{ total_notificaciones }} {{ $t("page.header_logo.notificaciones_nuevas") }}
                    </h4>
                    <h4
                      class="m-b-0 m-t-5"
                      v-else-if="total_notificaciones == 1"
                    >
                      {{ total_notificaciones }} {{ $t("page.header_logo.notificacion_nueva") }}
                    </h4>
                    <h4 class="m-b-0 m-t-5" v-else>{{ $t("page.header_logo.no_tienes_notificaciones") }}</h4>
                  </div>
                </li>
                <li>
                  <div class="message-center notifications">
                    <!-- Message -->
                    <a
                      href=""
                      v-on:click.prevent="Ver_Notificacion(notificacion)"
                      v-for="notificacion,index of notificaciones" :key="index+'not'"
                      class="message-item"
                    >
                      <span class="btn btn-danger btn-circle">
                        <i
                          v-if="notificacion.icono.length > 5"
                          v-bind:class="notificacion.icono"
                        ></i>
                        <i v-else class="fa fa-link"></i>
                      </span>
                      <div class="mail-contnet">
                        <h5 class="message-title">
                          {{ notificacion.titulo }}
                        </h5>
                        <span class="mail-desc">
                          {{ notificacion.contenido }}
                        </span>
                        <span class="time">
                          {{ notificacion.fecha }}
                        </span>
                      </div>
                    </a>
                  </div>
                </li>
                <li>
                  <a
                    class="nav-link text-center text-dark"
                    href=""
                    v-on:click.prevent="ejecutar_ruta('Notificaciones')"
                  >
                    <strong> {{ $t("page.header_logo.ver_notificaciones") }} </strong>
                  </a>
                </li>
              </ul>
            </div>
          </li>
          <li
            v-bind:style="{
              color: cia.color_texto_header
            }"
            class="nav-item dropdown"
          >
            <a
              v-bind:style="{
                color: cia.color_texto_header
              }"
              class="nav-link dropdown-toggle waves-effect waves-dark"
              href=""
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span
                v-bind:style="{
                  color: cia.color_texto_header
                }"
                class="badge-notification mt-5"
                v-bind:data-badge="total_sesiones"
              >
                <i
                  v-bind:style="{
                    color: cia.color_texto_header
                  }"
                  class="fas fa-users font-20"
                />
              </span>
            </a>
            <div class="dropdown-menu mailbox animated bounceInDown">
              <span class="with-arrow">
                <span class="bg-primary"></span>
              </span>
              <ul
                class="list-style-none"
                @click="
                  ev => {
                    ev.stopPropagation();
                  }
                "
              >
                <li>
                  <div class="drop-title bg-danger text-white">
                    <span class="font-light" v-if="total_sesiones > 0"
                      >{{ $t("page.header_logo.usuarios_activos") }}</span
                    >
                  </div>
                </li>
                <li>
                  <div class="message-center notifications">
                    <!-- Message -->
                    <a
                      href="javascript:void(0)"
                      v-for="sesion of sesiones"
                      class="message-item"
                      :key="'sesion' + sesion.clave"
                      @click="
                        ev => {
                          ev.stopPropagation();
                        }
                      "
                    >
                      <div class="container">
                        <div class="row justify-content-between w-100">
                          <div class="col-10">
                            <span class="btn btn-sm btn-danger btn-circle">
                              <i class="fa fa-link"></i>
                            </span>
                            <div
                              class="mail-contnet"
                              style="display:inline-flex;"
                            >
                              <span class="mail-desc">
                                {{ sesion.nombre }}
                              </span>
                            </div>
                          </div>
                          <div
                            class="col-2"
                            v-if="
                              usuario.usuario_sistema == 'Administrador' ||
                                usuario.usuario_sistema == 'HISE'
                            "
                          >
                            <button
                              class="btn btn-success btn-md"
                              v-on:click="liberar_sesion(sesion.clave)"
                            >
                              <i class="fas fa-cogs"></i>
                            </button>
                          </div>
                          <div
                            class="col-2"
                            v-else-if="
                              usuario.usuario_sistema == 'Rep. Empresa' &&
                                usuario.subordinados.includes(sesion.clave)
                            "
                          >
                            <button
                              class="btn btn-success btn-md"
                              v-on:click="liberar_sesion(sesion.clave)"
                            >
                              <i class="fas fa-cogs"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </li>
          <li>
            <div style="width: 100px;"></div>
          </li>
          <li>
          </li>
        </ul>
        <ul
          class="mr-auto"
        >
          <li
            v-if="cia.dashboard_show_header_logo == '1' ? true : false"
            class="center-image"
          >
            <img :src="cia.dashboard_header_logo" style="width: 50%;"/>
          </li>
        </ul>
        <ul
          v-bind:style="{
            color: cia.color_texto_header
          }"
          class="navbar-nav float-right"
        >
          <li
            v-bind:style="{
              color: cia.color_texto_header
            }"
            class="nav-item search-box d-none"
          >
            <a
              v-bind:style="{
                color: cia.color_texto_header
              }"
              class="nav-link waves-effect waves-dark"
              href=""
              v-on:click.prevent="ejecutar_ruta('Teams')"
            >
              <i
                v-bind:style="{
                  color: cia.color_texto_header
                }"
                class="fas fa-video pt-3 font-20"
              />
            </a>
          </li>
          <li
            v-bind:style="{
              color: cia.color_texto_header
            }"
            class="nav-item search-box"
            v-show="
              usuario_permisos.nomseccion1.indexOf('Dashboard') >= 0 &&
                usuario_permisos.nomseccion2.indexOf('Ayuda') >= 0 &&
                usuario_permisos.nomseccion3.indexOf('Envio ticket') >= 0
            "
          >
            <a
              v-bind:style="{
                color: cia.color_texto_header,
              }"
              class="nav-link waves-effect waves-dark"
              href=""
              v-on:click.prevent="ejecutar_ruta('Ayuda')"
            >
              <i
                v-bind:style="{
                  color: cia.color_texto_header,
                  'font-size':'1.5em'
                }"
                class="fas fa-ticket-alt"
              ></i>
            </a>
          </li>
          <li
            v-bind:style="{
              color: cia.color_texto_header
            }"
            class="nav-item search-box"
            v-show="
              usuario_permisos.nomseccion1.indexOf('APIs Externas') >= 0 &&
                usuario_permisos.nomseccion2.indexOf('Consultar APIs') >= 0
            "
          >
            <a
              v-bind:style="{
                color: cia.color_texto_header
              }"
              class="nav-link waves-effect waves-dark"
              href=""
              v-on:click.prevent="ejecutar_ruta('Apis')"
            >
              <i
                v-bind:style="{
                  color: cia.color_texto_header
                }"
                class="fas fa-paper-plane font-16"
              ></i>
            </a>
          </li>
          <li
            v-bind:style="{
              color: cia.color_texto_header
            }"
            class="nav-item search-box"
            v-show="
                usuario_permisos.nomseccion2.indexOf('Creación perfiles') >= 0
            "
          >
            <a
              v-bind:style="{
                color: cia.color_texto_header
              }"
              class="nav-link waves-effect waves-dark"
              href=""
              v-on:click.prevent="ejecutar_ruta('creacion_Perfiles')"
            >
              <i
                v-bind:style="{
                  color: cia.color_texto_header
                }"
                class="fas fa-user-plus font-16"
              ></i>
            </a>
          </li>
          <li
            v-bind:style="{
              color: cia.color_texto_header
            }"
            class="nav-item search-box"
            v-show="
              usuario_permisos.nomseccion1.indexOf('Panel de Cursos') >= 0 &&
                usuario_permisos.nomseccion2.indexOf('Ver Panel de Cursos') >= 0
            "
          >
            <a
              v-bind:style="{
                color: cia.color_texto_header
              }"
              class="nav-link waves-effect waves-dark"
              href=""
              v-on:click.prevent="ejecutar_ruta('Panel_Cursos')"
            >
              <i
                v-bind:style="{
                  color: cia.color_texto_header
                }"
                class="fas fa-tv font-16"
              />
            </a>
          </li>
          <li
            v-bind:style="{
              color: cia.color_texto_header
            }"
            class="nav-item dropdown"
            v-show="
              usuario_permisos.nomseccion1.indexOf('Configuración') >= 0 &&
                usuario_permisos.nomseccion2.indexOf('Ver Configuración') >= 0
            "
          >
            <a
              v-bind:style="{
                color: cia.color_texto_header
              }"
              class="nav-link waves-effect waves-dark"
              href=""
              v-on:click.prevent="ejecutar_ruta('Configuracion')"
            >
              <i
                v-bind:style="{
                  color: cia.color_texto_header
                }"
                class="fas fa-cog font-18"
              />
            </a>
          </li>
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdown2"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i class="flag-icon font-18" :class="$i18n.locale == 'es'?'flag-icon-mx':$i18n.locale == 'pt'?'flag-icon-br':'flag-icon-us'"></i>
            </a>
            <div
              class="dropdown-menu dropdown-menu-right animated bounceInDown"
              aria-labelledby="navbarDropdown2"

            >
              <a
                class="dropdown-item"
                href="#"
                @click="cambiarIdioma('es')"
              >
                <i class="flag-icon flag-icon-mx"></i> {{ $t("page.header_logo.espanol") }}</a
              >
              <a
                class="dropdown-item"
                href="#"
                @click="cambiarIdioma('en')"
              >
                <i class="flag-icon flag-icon-us"></i> {{ $t("page.header_logo.ingles") }}</a
              >
              <!-- <a
                class="dropdown-item"
                href="#"
                @click="
                  () => {
                    $i18n.locale = 'pt';
                  }
                "
              >
                <i class="flag-icon flag-icon-br"></i> {{ $t("page.header_logo.portugues") }}</a
              > -->
            </div>
          </li>
          <li
            v-bind:style="{
              color: cia.color_texto_header
            }"
            class="nav-item dropdown d-none d-lg-block"
          >
            <a
              v-bind:style="{
                color: cia.color_texto_header
              }"
              class="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdown2"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <!-- {{ menu.usuario.usuario_sistema }} -->
              {{ $t(`page.general.${toSnakeCase(menu.usuario.usuario_sistema )}`) }}
              <i
                v-bind:style="{
                  color: cia.color_texto_header
                }"
                class="fas fa-caret-down"
              ></i>
            </a>
            <div
              class="dropdown-menu dropdown-menu-right animated bounceInDown"
              aria-labelledby="navbarDropdown2"
            >
              <a
                class="dropdown-item"
                href=""
                v-on:click.prevent="Cambiar_Perfil_Usuario(perfil)"
                v-for="perfil,index of menu.usuario.perfiles_sistema" :key="index+'perfil'"
              >
                <!-- {{ perfil }} -->
                {{ $t(`page.general.${toSnakeCase(perfil )}`) }}
              </a>
            </div>
          </li>
          <li class="nav-item dropdown">
            <a
              class="
                nav-link
                dropdown-toggle
                text-muted
                waves-effect waves-dark
                pro-pic
              "
              href=""
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <img
                :src="fotoEmpleadoHeaderSrc"
                alt="user"
                class="rounded-circle"
                width="31"
                referrerpolicy="no-referrer"
                @error="onFotoEmpleadoHeaderError"
              />
            </a>
            <div
              class="dropdown-menu dropdown-menu-right user-dd animated flipInY"
            >
              <span class="with-arrow">
                <span class="bg-danger"></span>
              </span>
              <div
                class="
                  d-flex
                  no-block
                  align-items-center
                  p-15
                  bg-danger
                  text-white
                  m-b-10
                  p-3
                "
              >
                <div class="m-l-10 ml-2" style="text-transform: none;">
                  <h4 class="m-b-0">{{ menu.usuario.nombre_empleado }}</h4>
                  <p class="m-b-0">{{ menu.usuario.correo_empleado }}</p>
                  <span id="cambioContrasena" @click="cambiarContrasena()"
                    >{{ $t("page.header_logo.cambio_contraseña") }}</span
                  >
                  <br>
                  <span id="cambioContrasena" @click="actualizarPerfil()"
                    >{{ $t("page.header_logo.actualizar_perfil") }}</span
                  >
                  <br>

                  <div v-if="cia.enable_ecommerce == '1'">
                    <span
                      v-if="usuario.perfil_sistema === 8 || usuario.perfil_sistema === '8'"
                      id="miFacturacion"
                      @click="irAFacturacion"
                      >{{ $t("page.header_logo.mi_facturacion") }}</span
                    >
                    <span
                      v-if="usuario.perfil_sistema === 128 || usuario.perfil_sistema === '128'"
                      id="miFacturacion"
                      @click="irAHistorialCompras"
                      >{{ $t("page.header_logo.historial_compras") }}</span
                    >
                  </div>
                </div>
              </div>
              <div class="dropdown-divider"></div>
              <a
                class="dropdown-item text-center"
                href=""
                v-on:click.prevent="Salir"
              >
                <i class="fa fa-power-off m-r-5 m-l-5"></i> {{ $t("page.header_logo.cerrar") }}</a
              >
            </div>
          </li>
        </ul>
      </div>
    </nav>
    <button
      class="btn btn-sm btn-danger d-none"
      id="Cerrar_Sesion_LMS"
      v-on:click="Salir"
    >
      {{ $t("page.header_logo.salir") }}
    </button>


    <b-modal ref="my-modal" id="modal-center"size="xl" hide-backdrop centered title="BootstrapVue">

    <template #modal-header="{ close }">
      <h5>{{ $t("page.header_logo.actualizar_perfil") }}</h5>
    </template>

    <form ref="myForm" v-on:submit.prevent="actualizarUsuario" id="register">
      <div class="text-center">
        <img class="foto-empleado rounded-circle img-fluid" width="15%" :src="foto_empleado" alt="" srcset="">
        <p>

          <div
            class="col-4 text-left"
          >
          </div>
          <div
            class="form-group col-4"
            v-show="false"
          >
            <label for="link_img">{{
              $t("page.content_empleados.tabla.seleccionad_foto")
            }}</label>
            <input
              type="file"
              v-on:change="Cambio_Imagen"
              class="form-control-file"
              accept="image/x-png,image/gif,image/jpeg"
              id="link_img"
            />
          </div>
          <button
            type="button"
            class="btn btn-success mt-1"
            v-on:click="Cambiar_Imagen"
          >
            <span>{{ $t("page.content_empleados.tabla.cambiar_foto") }}</span>
          </button>
        </p>
      </div>
      <div class="row">
        <div class="col-6 form-group mb-3">
          <label for="nombre_empleado">{{ $t("page.general.nombre") }}</label>
          <input
            type="text"
            class="form-control"
            id="nombre_empleado"
            v-model="nombre_empleado"
            required
          />
        </div>
        <div class="col-6 form-group mb-3">
          <label for="nombre">{{ $t("page.general.telefono") }}</label>
          <input
            type="text"
            class="form-control"
            id="telefono"
            v-model="telefono"
            @keypress="onlyNumbers"
            required
          />
        </div>
        <div class="col-6 form-group mb-3">
          <label for="nombre">{{ $t("page.general.rfc") }}</label>
          <input
            type="text"
            class="form-control"
            id="rfc"
            v-model="rfc"
            required
            maxlength="13"
            minlength="12"
          />
          <small
            v-if="rfc && !rfcValido"
            class="text-danger d-block mt-1"
          >
            El RFC debe tener entre 12 y 13 caracteres.
          </small>
        </div>
        <div class="col-6 form-group mb-3">
          <label for="nombre">{{ $t("page.general.correo") }}</label>
          <input
            type="email"
            class="form-control"
            id="correo"
            v-model="correo"
            required
          />
        </div>
        <div class="col-6 form-group mb-3">
          <label for="nombre">{{ $t("page.general.genero") }}</label>
          <select
            class="form-control"
            v-model="genero"
            id="genero"
            required
          >
            <option :value="null">-- {{ $t("page.general.selecciona_genero") }} --</option>
            <option value="H">
              {{ $t("page.general.hombre") }}
            </option>
            <option value="M">
              {{ $t("page.general.mujer") }}
            </option>
          </select>
        </div>
        <div class="col-6 form-group mb-3">
          <label for="nombre">{{ $t("page.general.fecha_nacimiento") }}</label>
          <input
            type="date"
            class="form-control"
            id="fechaNacimiento"
            v-model="fechaNacimiento"
            required
          />
        </div>

      </div>
    </form>
    <template #modal-footer="{ ok, cancel }">
      <button
        class="btn btn-danger"
        @click="cancel()"
      >
        <span>{{ $t("page.general.cancelar") }}</span>
      </button>
      <button
        type="submit"
        class="btn btn-success"
        :disabled="loading"
        @click="submitForm"
      >
        <span v-if="loading"><b-spinner label="Spinning"></b-spinner></span>
        <span v-if="!loading">{{ $t("page.general.actualizar") }}</span>
      </button>
    </template>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { firestore, database, storage } from "@/firebase.js";
import VueJwtDecode from "vue-jwt-decode";

/** Logo servido por el mismo host si Firebase no entrega URL o la imagen remota falla */
const LOGO_HEADER_LOCAL = "/static/img/logo-header-local.png";
/** Foto de perfil en header si la URL falla o no hay imagen */
const FOTO_EMPLEADO_DEFAULT = "/static/img/empleados/foto_base.png";

export default {
  data() {
    return {
      /** Tras error de carga (404, 412, CORS, etc.) sobre la URL remota */
      logoFirebaseLoadFailed: false,
      /** URL actualizada vía SDK (token/generación coherente; evita GET 412 con URL vieja) */
      logoStorageResolvedUrl: "",
      sesiones: [],
      langs: [],
      nombre_empleado: '',
      ocupacion: null,
      estado: null,
      telefono: '',
      curp: '',
      rfc: '',
      rfc_original: '',
      correo: '',
      correo_original: '',
      foto_empleado: '',
      genero: null,
      fechaNacimiento: '',
      loading: false,
      /** Tras error de carga (404, CORS, etc.) sobre la foto del usuario en el header */
      fotoEmpleadoHeaderFailed: false,
    };
  },
  methods: {
    toSnakeCase(str) {
      if (!str) {
        return '';
      }
      return str
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/\s+/g, "_")
        .replace(/[^\w_]/g, "");
    },
    cambiarIdioma(idioma) {
      this.$i18n.locale = idioma;
      this.Consultar_Tooltips();
      this.Definir_Tooltip_De_La_Seccion();
    },
    irAFacturacion() {
      this.$router.push({ name: "mi_facturacion"});
    },
    irAHistorialCompras() {
      this.$router.push({ name: "historial_compras"});
    },
    submitForm() {
      this.$refs.myForm.requestSubmit();
    },
    Cambio_Imagen() {
      var that = this;
      var file = document.querySelector("#link_img")["files"][0];
      if (file != null) {
        var reader = new FileReader();
        var baseString;
        reader.onloadend = function() {
          baseString = reader.result;
          that.foto_empleado = baseString;
          var imagen = $(
            '<img src="' +
              that.foto_empleado +
              '" alt="" class="rounded-circle img-fluid">'
          );
          $("#imagen_nueva_empleado")
            .empty()
            .append(imagen);
        };
        reader.readAsDataURL(file);
      }
    },
    Cambiar_Imagen() {
      this.cambiando_imagen = true;
      $("#link_img").val(null);
      $("#link_img").click();
    },
    actualizarUsuario() {
      if (!this.rfcValido) {
        swal(
          "RFC inv\u00e1lido",
          "El RFC debe tener entre 12 y 13 caracteres.",
          "warning"
        );
        return;
      }

      if (this.mensajeAdvertenciaMetodoAccesoPerfil) {
        swal({
          title: "Advertencia",
          text: this.mensajeAdvertenciaMetodoAccesoPerfil,
          icon: "warning",
          buttons: {
            cancel: "Cancelar",
            confirm: {
              text: "Continuar",
              value: true,
              visible: true,
              className: "",
              closeModal: true
            }
          }
        }).then((continuar) => {
          if (continuar) {
            this.actualizarUsuarioPerfil();
          }
        });
        return;
      }

      this.actualizarUsuarioPerfil();
    },
    actualizarUsuarioPerfil() {
      this.loading = true;

      const body = {
        "cve_empleado": this.menu.usuario.cve_empleado,
        "nombre_empleado": this.nombre_empleado,
        "genero": this.genero,
        "correo_empleado": this.correo,
        "rfc_empleado": this.rfc,
        "fecha_nacimiento": this.fechaNacimiento,
        "telefono": this.telefono,
        "foto_empleado": this.foto_empleado,
      };

      this.$http
        .post("usuarios/actualizar-perfil", body)
        .then((respuesta) => {
          return respuesta.json();
        })
        .then((respuestaJson) => {
          if (!respuestaJson || respuestaJson.resp !== "Excelente") {
            swal(
              "¡Ups!",
              (respuestaJson && respuestaJson.resp) ? respuestaJson.resp : "Hubo problemas para actualizar su perfil",
              "error"
            );
            return;
          }

          this.correo_original = this.correo;
          this.rfc_original = this.rfc;
          const tokenActualizado = (
            respuestaJson &&
            respuestaJson.user &&
            respuestaJson.user[0] &&
            respuestaJson.user[0].token
          ) ? respuestaJson.user[0].token : null;

          if (tokenActualizado) {
            localStorage.apiKey_lms = JSON.stringify(tokenActualizado);
            this.Actualizar_Token(tokenActualizado);
            var usuario_datos = VueJwtDecode.decode(tokenActualizado);
            this.$store.state.menu.usuario = usuario_datos.data;
          }

          swal(
            'Excelente',
            'Se actualizó tu perfil de manera correcta. Se va a recargar la pagina para que los cambios tengan efecto',
            'success',
          ).then(() => {
            location.reload();
          });
        })
        .catch((error) => {
          console.log("Error en Iniciar_Sesion", error);
          swal(
            "Problemas para conectarse",
            "Favor de revisar su conexión a internet (2)",
            "error"
          );
          toastr.error(
            "¿Tienes problemas para ingresar? comunicate con tu representante de empresa"
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    Validar_Permisos(token) {
      var that = this;
      this.$store.dispatch("Definir_Opciones_Menu_Lateral").then((data) => {
        location.reload();
      });
    },
    Continuar_Menu(token) {
      var that = this;
      localStorage.removeItem("apiKey_lms");
      localStorage.apiKey_lms = JSON.stringify(token);
      this.$router.push({ name: "Menu", params: { origin: "Login" } });
    },
    Actualizar_Usuario(usuario, token) {
      var that = this;
      this.$store
        .dispatch("Actualizar_Usuario", { usuario: usuario, token: token })
        .then((data) => {
          that.Validar_Permisos(token);
        });
    },
    actualizarPerfil() {
      this.nombre_empleado = this.menu.usuario.nombre_empleado;
      this.telefono = this.menu.usuario.telefono;
      this.rfc = this.menu.usuario.rfc_empleado;
      this.rfc_original = this.menu.usuario.rfc_empleado;
      this.correo = this.menu.usuario.correo_empleado;
      this.correo_original = this.menu.usuario.correo_empleado;
      this.genero = this.menu.usuario.genero;
      this.fechaNacimiento = this.menu.usuario.fecha_nacimiento;
      this.foto_empleado = this.menu.usuario.foto_empleado;
      this.curp = this.menu.usuario.curp;
      this.estado = this.menu.usuario.cve_estado;
      this.ocupacion = this.menu.usuario.puesto;
      this.$refs['my-modal'].show();
    },
    onlyNumbers(event) {
      // Verificar si el carácter es un número
      const charCode = event.charCode;
      if (charCode < 48 || charCode > 57) {
        event.preventDefault(); // Prevenir que se inserte el carácter
      }
    },
    cambiarContrasena() {
      $("#modalChangePass").modal();
    },
    ejecutar_ruta(route_name) {
      this.$router.push({ name: route_name });
    },
    onLogoHeaderError() {
      if (this.logoFirebaseLoadFailed || !this.logoFirebaseUrl) {
        return;
      }
      this.logoFirebaseLoadFailed = true;
    },
    onFotoEmpleadoHeaderError() {
      if (this.fotoEmpleadoHeaderFailed) {
        return;
      }
      this.fotoEmpleadoHeaderFailed = true;
    },
    Dashboard() {
      this.$router.push({ name: "Dashboard" });
    },
    Salir() {
      this.menu.salir = true;
      this.logout();
      this.$http
        .delete(
          "../pri/usuarios/sesiones/eliminar/" +
            this.menu.usuario.cve_empleado +
            "/web"
        )
        .then(respuesta => {
          return respuesta.json();
        })
        .then(respuestaJson => {
          this.Actualizar_Token(this.menu.tokenGenerico);
          localStorage.removeItem("carrito");
          this.$router.push({ name: "Login" });
          location.reload(true);
        })
        .catch(error => {
          this.Actualizar_Token(this.menu.tokenGenerico);
          this.$router.push({ name: "Login" });
          location.reload(true);
        });
    },
    liberar_sesion(clave) {
      let that = this;
      firestore
        .collection("empresas")
        .doc(that.cia.firebase_firestore)
        .collection("status")
        .doc(clave)
        .update({ state: "offline" })
        .then(() => {
          database
            .ref("empresas/" + that.cia.firebase_firestore + "/status/" + clave)
            .update({ state: "offline" })
            .then(() => {
              toastr.success("Sesión liberada con exito!");
            })
            .catch(() => {
              toastr.error(
                "Hubo un problema para liberar la sesión, por favor contacta al proveedor."
              );
            });
        })
        .catch(() => {
          toastr.error(
            "Hubo un problema para liberar la sesión, por favor contacta al proveedor."
          );
        });
    },
    ...mapActions([
      "Actualizar_Token",
      "Actualizar_Empresa",
      "Actualizar_Notificaciones",
      "Ver_Notificacion",
      "Actualizar_Notificacion",
      "Cambiar_Perfil_Usuario",
      'logout',
      'Definir_Tooltip_De_La_Seccion',
      "Consultar_Tooltips",
    ]),
    ...mapGetters(['getItemsCount']),
  },
  computed: {
    usuario() {
      return this.$store.getters.getUsuario;
    },
    menu() {
      return this.$store.getters.getMenu;
    },
    cia() {
      return this.$store.getters.getCia;
    },
    empresa() {
      return this.$store.getters.getEmpresa;
    },
    logoFirebaseUrl() {
      const v =
        this.empresa && this.empresa.logo != null
          ? String(this.empresa.logo).trim()
          : "";
      return v;
    },
    logoHeaderSrc() {
      if (!this.logoFirebaseUrl || this.logoFirebaseLoadFailed) {
        return LOGO_HEADER_LOCAL;
      }
      return this.logoStorageResolvedUrl || this.logoFirebaseUrl;
    },
    fotoEmpleadoHeaderSrc() {
      if (this.fotoEmpleadoHeaderFailed) {
        return FOTO_EMPLEADO_DEFAULT;
      }
      const u =
        this.menu &&
        this.menu.usuario &&
        this.menu.usuario.foto_empleado != null
          ? String(this.menu.usuario.foto_empleado).trim()
          : "";
      if (!u) {
        return FOTO_EMPLEADO_DEFAULT;
      }
      return u;
    },
    total_notificaciones() {
      return this.$store.getters.getTotalNotificaciones_No_Leidas;
    },
    notificaciones() {
      return this.$store.getters.getNotificaciones;
    },
    notificacion() {
      return this.$store.getters.getNotificacion;
    },
    mensajeAdvertenciaMetodoAccesoPerfil() {
      const registerPasswordMethod = (this.cia.register_password_method || "")
        .toLowerCase()
        .trim();

      if (registerPasswordMethod === "correo") {
        if ((this.correo_original || "") !== (this.correo || "")) {
          return "Se modifico tu correo. Este dato se usa como metodo de acceso y el cambio puede ocasionar problemas para ingresar.";
        }
      }

      if (registerPasswordMethod === "rfc") {
        if ((this.rfc_original || "").trim() !== this.rfcNormalizado) {
          return "Se modifico tu RFC. Este dato se usa como metodo de acceso y el cambio puede ocasionar problemas para ingresar.";
        }
      }

      return "";
    },
    rfcNormalizado() {
      return (this.rfc || "").replace(/\s+/g, "").trim();
    },
    rfcValido() {
      return this.rfcNormalizado === "" || (
        this.rfcNormalizado.length >= 12 &&
        this.rfcNormalizado.length <= 13
      );
    },
    usuario_permisos() {
      return this.$store.getters.getUsuario_Permisos;
    },
    total_sesiones: function() {
      return this.sesiones.length;
    }
  },
  watch: {
    "menu.usuario.foto_empleado"() {
      this.fotoEmpleadoHeaderFailed = false;
    },
    logoFirebaseUrl: {
      immediate: true,
      handler(v) {
        this.logoFirebaseLoadFailed = false;
        this.logoStorageResolvedUrl = "";
        if (!v || String(v).indexOf("firebasestorage.googleapis.com") === -1) {
          return;
        }
        const that = this;
        const raw = String(v).trim();
        let refObj;
        try {
          refObj = storage.refFromURL(raw);
        } catch (e) {
          return;
        }
        refObj
          .getDownloadURL()
          .then(function (fresh) {
            if (that.logoFirebaseUrl !== raw) {
              return;
            }
            that.logoFirebaseLoadFailed = false;
            that.logoStorageResolvedUrl = fresh;
          })
          .catch(function () {
            /* se usa logoFirebaseUrl tal cual; @error activará fallback local */
          });
      }
    },
    "cia.firebase_firestore": function() {
      var that = this;
      that.$bind(
        "sesiones",
        firestore
          .collection("empresas")
          .doc(that.cia.firebase_firestore)
          .collection("status")
          .where("state", "==", "online")
          .orderBy("last_changed", "desc")
      );
    }
  },
  created() {
    var that = this;

    if (this.getItemsCount() > 0) {
      toastr.options.onclick = function (e) {
        that.$router.push({ name: "checkout" });
      }

      toastr.info(
        "Tienes contenido en tu carrito de compras",
        '',
        {hideDuration: 5000}
      );
      toastr.options.onclick = null;
    }
  },
  mounted() {
    var that = this;
    if (this.cia.firebase_firestore != "") {
      that.$bind(
        "sesiones",
        firestore
          .collection("empresas")
          .doc(that.cia.firebase_firestore)
          .collection("status")
          .where("state", "==", "online")
          .orderBy("last_changed", "desc")
      );
    }
  }
};
</script>

<style>
.center-image {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
#cambioContrasena {
  text-decoration: underline;
  cursor: pointer;
}
#miFacturacion {
  text-decoration: underline;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/AppLms/Menu/HeaderLogo.vue